export default __webpack_public_path__ + "static/top_msquare_bg-beaface60c496efc9bea402109e4c946.jpg";